import { render, staticRenderFns } from "./MenuCameraPermissions.vue?vue&type=template&id=f5302016"
import script from "./MenuCameraPermissions.vue?vue&type=script&lang=js"
export * from "./MenuCameraPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports